var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3128 4.15625V8.90625C18.3128 9.06372 18.2503 9.21475 18.1389 9.32609C18.0276 9.43744 17.8766 9.5 17.7191 9.5C17.5616 9.5 17.4106 9.43744 17.2992 9.32609C17.1879 9.21475 17.1253 9.06372 17.1253 8.90625V5.58941L11.0142 11.7013C10.959 11.7565 10.8935 11.8003 10.8215 11.8302C10.7494 11.8601 10.6721 11.8755 10.5941 11.8755C10.5161 11.8755 10.4388 11.8601 10.3667 11.8302C10.2946 11.8003 10.2291 11.7565 10.174 11.7013L7.62533 9.15191L2.70166 14.0763C2.59025 14.1877 2.43914 14.2503 2.28158 14.2503C2.12402 14.2503 1.97291 14.1877 1.8615 14.0763C1.75009 13.9649 1.6875 13.8138 1.6875 13.6562C1.6875 13.4987 1.75009 13.3476 1.8615 13.2362L7.20525 7.89242C7.2604 7.83722 7.32588 7.79342 7.39796 7.76354C7.47004 7.73366 7.5473 7.71828 7.62533 7.71828C7.70336 7.71828 7.78062 7.73366 7.8527 7.76354C7.92478 7.79342 7.99026 7.83722 8.04541 7.89242L10.5941 10.4418L16.2859 4.75H12.9691C12.8116 4.75 12.6606 4.68744 12.5492 4.57609C12.4379 4.46474 12.3753 4.31372 12.3753 4.15625C12.3753 3.99878 12.4379 3.84776 12.5492 3.73641C12.6606 3.62506 12.8116 3.5625 12.9691 3.5625H17.7191C17.8766 3.5625 18.0276 3.62506 18.1389 3.73641C18.2503 3.84776 18.3128 3.99878 18.3128 4.15625Z",
    fill: "#02AF6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUp);
export default __webpack_public_path__ + "static/media/graph_up.32523fb81964966caa41510c122202ff.svg";
export { ForwardRef as ReactComponent };